
import { defineComponent, PropType } from 'vue';

interface PickerUser { id: number; name: string; designation: string | null }

/** Searchable staff list; single (radio) or multiple (checkbox) selection via v-model. */
export default defineComponent({
  name: 'UserPicker',
  props: {
    users: { type: Array as PropType<PickerUser[]>, default: () => [] },
    modelValue: { type: [Number, Array] as PropType<number | number[] | null>, default: null },
    multiple: { type: Boolean, default: false },
    exclude: { type: Array as PropType<number[]>, default: () => [] },
  },
  emits: ['update:modelValue'],
  data() {
    return { term: '' };
  },
  computed: {
    filtered(): PickerUser[] {
      const term = this.term.trim().toLowerCase();
      return this.users
        .filter(u => !this.exclude.includes(Number(u.id)))
        .filter(u => !term || (u.name + ' ' + (u.designation || '')).toLowerCase().includes(term))
        .slice(0, 80);
    },
  },
  methods: {
    isSelected(id: number): boolean {
      return this.multiple ? ((this.modelValue as number[]) || []).includes(id) : this.modelValue === id;
    },
    toggle(id: number) {
      if (!this.multiple) {
        this.$emit('update:modelValue', id);
        return;
      }
      const current = [...((this.modelValue as number[]) || [])];
      const at = current.indexOf(id);
      if (at >= 0) {
        current.splice(at, 1);
      } else {
        current.push(id);
      }
      this.$emit('update:modelValue', current);
    },
  },
});
